import Agency from '../views/agency/Agency.vue'
import AgencyList from '../views/agency/AgencyList.vue'
import InviteOwner from '../views/agency/InviteOwner.vue'
import NewAgency from '../views/agency/NewAgency.vue'

import layouts from '../layout'

export default {
	path: '/agency',
    name: 'agency',
    component: Agency,
	meta: {
		auth: true,
		layout: layouts.navLeft
	},
	children: [
		{
			path: 'list',
			name: 'agency-list',
			component: AgencyList,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				title: 'Agency List',
				tags: ['agency']
			}
		},
		{
			path: 'invite',
			name: 'invite-owner',
			component: InviteOwner,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				title: 'Invite Owner',
				tags: ['invite', 'owner']
			}
        },
        {
			path: 'new',
			name: 'new-agency',
			component: NewAgency,
			meta: {
				auth: true,
				layout: layouts.navLeft,
				searchable: true,
				title: 'Onboard Agency',
				tags: ['onboard']
			}
		}
	]
}



// WEBPACK FOOTER //
// ./src/router/agency.js